import type React from 'react'
import type { JSX } from 'react'
import { cn } from '@/lib/styles'

export type ContainerTag = Extract<'div' | 'section', keyof JSX.IntrinsicElements>
export interface ContainerProps {
	readonly children: React.ReactNode
	readonly className?: string
	readonly paddingX?: boolean
	readonly paddingY?: boolean
	readonly paddingTop?: boolean
	readonly paddingBottom?: boolean
	readonly tag?: ContainerTag
}

export const Container = ({
	children,
	className,
	paddingX = false,
	paddingY = false,
	paddingTop = false,
	paddingBottom = false,
	tag = 'div',
	...rest
}: ContainerProps & React.HTMLAttributes<HTMLElement>) => {
	const combinedClassName = cn(
		'mx-auto w-full',
		paddingX ? 'lg:max-w-344.5 px-6 lg:px-11' : 'max-w-322.5',
		paddingY && 'py-12 lg:py-20',
		paddingTop && 'pt-12 lg:pt-20',
		paddingBottom && 'pb-12 lg:pb-20',
		className,
	)

	const Tag = tag

	if (!Tag) {
		return null
	}

	return (
		<Tag className={combinedClassName} {...rest}>
			{children}
		</Tag>
	)
}
